import { defaultAxios, IParams } from '../base';

export interface IMutatePreReq extends IParams {
    // todo parameter 추가 예정
}

// 가심사 신청
export const mutatePreReq = async (params: IMutatePreReq) => {
    return await defaultAxios().put(`/house/preReq`, params);
};
